import axios from 'axios'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001/api'

const api = axios.create({ baseURL: API })

const rotasPublicas = ['/formulario/', '/documentos-tipo/', '/tipos/publico/', '/processos/publico/', '/configuracoes/publico/', '/processos/consulta-publica/', '/protocolo-publico/']

function getToken(url, method) {
  const isPublica = rotasPublicas.some(r => url.includes(r))
  // GET é público, mas PUT/DELETE/POST precisam de token mesmo em rotas "públicas"
  if (isPublica && method && method.toUpperCase() !== 'GET') {
    return localStorage.getItem('pg_token')
  }
  if (isPublica) return null

  if (url.includes('/portal/')) {
    const keys = Object.keys(localStorage).filter(k => k.startsWith('pg_portal_token_'))
    if (keys.length > 0) return localStorage.getItem(keys[0])
    return localStorage.getItem('pg_portal_token')
  }

  return localStorage.getItem('pg_token')
}

api.interceptors.request.use(config => {
  const token = getToken(config.url || '', config.method)
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(r => r, err => {
  const url = err.config?.url || ''
  const isPortal = url.includes('/portal/')
  const isPublica = rotasPublicas.some(r => url.includes(r))
  if (!isPortal && !isPublica && (err.response?.status === 401 || err.response?.status === 403)) {
    localStorage.removeItem('pg_token'); localStorage.removeItem('pg_usuario')
    window.location.href = '/login'
  }
  return Promise.reject(err)
})

export const login = (email, senha) => api.post('/auth/login', { email, senha })
export const listarProcessos = (params) => api.get('/processos', { params })
export const abrirProcesso = (dados) => api.post('/processos', dados)
export const buscarProcesso = (id) => api.get(`/processos/${id}`)
export const tramitarProcesso = (id, dados) => api.post(`/processos/${id}/tramitar`, dados)
export const consultarPublico = (numero) => api.get(`/processos/publico/${encodeURIComponent(numero)}`)
export const processosRelacionados = (id) => api.get(`/processos/${id}/relacionados`)
export const apensarProcesso = (id, dados) => api.post(`/processos/${id}/apensar`, dados)
export const prazosVencendo = () => api.get('/processos/prazos/vencendo')
export const listarSecretarias = () => api.get('/secretarias')
export const criarSecretaria = (dados) => api.post('/secretarias', dados)
export const atualizarSecretaria = (id, dados) => api.put(`/secretarias/${id}`, dados)
export const deletarSecretaria = (id) => api.delete(`/secretarias/${id}`)
export const listarTipos = () => api.get('/tipos')
export const tiposPublico = (slug) => api.get(`/tipos/publico/${slug}`)
export const criarTipo = (dados) => api.post('/tipos', dados)
export const atualizarTipo = (id, dados) => api.put(`/tipos/${id}`, dados)
export const deletarTipo = (id) => api.delete(`/tipos/${id}`)
export const listarUsuarios = () => api.get('/usuarios')
export const criarUsuario = (dados) => api.post('/usuarios', dados)
export const atualizarUsuario = (id, dados) => api.put(`/usuarios/${id}`, dados)
export const cadastrarContribuintePresencial = (dados) => api.post('/usuarios/contribuinte-presencial', dados)
export const uploadDocumento = (processoId, arquivo) => {
  const form = new FormData(); form.append('arquivo', arquivo)
  return api.post(`/documentos/upload/${processoId}`, form, { headers: { 'Content-Type': 'multipart/form-data' } })
}
export const listarDocumentos = (processoId) => api.get(`/documentos/${processoId}`)
export const deletarDocumento = (id) => api.delete(`/documentos/${id}`)
export const portalCadastro = (dados) => api.post('/portal/cadastro', dados)
export const portalLogin = (dados) => api.post('/portal/login', dados)
export const portalMeusProcessos = () => api.get('/portal/meus-processos')
export const portalAbrirProcesso = (dados) => api.post('/portal/abrir-processo', dados)
export const portalUploadDoc = (processoId, arquivo) => {
  const form = new FormData(); form.append('arquivo', arquivo)
  return api.post(`/portal/upload/${processoId}`, form, { headers: { 'Content-Type': 'multipart/form-data' } })
}
export const portalListarDocs = (processoId) => api.get(`/portal/documentos/${processoId}`)
export const portalCampos = (tipoId) => api.get(`/portal/campos/${tipoId}`)
export const buscarCampos = (tipoId) => api.get(`/formulario/${tipoId}`)
export const buscarDocsTipo = (tipoId) => api.get(`/documentos-tipo/${tipoId}`)
export const buscarRespostas = (processoId) => api.get(`/formulario/respostas/${processoId}`)
export const salvarRespostas = (processoId, respostas) => api.post(`/formulario/respostas/${processoId}`, { respostas })
export const aprovacoesPendentes = () => api.get('/aprovacoes/pendentes')
export const responderAprovacao = (id, dados) => api.post(`/aprovacoes/${id}/responder`, dados)
export const historicoAprovacoes = (processoId) => api.get(`/aprovacoes/historico/${processoId}`)
export const listarModelos = () => api.get('/modelos')
export const criarModelo = (dados) => api.post('/modelos', dados)
export const atualizarModelo = (id, dados) => api.put(`/modelos/${id}`, dados)
export const deletarModelo = (id) => api.delete(`/modelos/${id}`)
export const resumirProcesso = (id) => api.post(`/ia/resumir/${id}`)
export const triagemIA = (dados) => api.post('/ia/triagem', dados)
export const listarAuditoria = (params) => api.get('/auditoria', { params })

export default api
